import Logo from '../../assets/images/logo.png'
import IcSearch from '../../assets/icons/seacrh.png'
import { useState } from 'react'
import { Link as LinkScroll } from 'react-scroll'
import { FaBars } from 'react-icons/fa'
import { FaXmark } from 'react-icons/fa6'

const Navbar = () => {
    const [openSearch, setOpenSearch] = useState(false)
    const [openMenu, setOpenMenu] = useState(false)
    return (
        <div className="w-full backdrop-blur-sm fixed top-0 left-0 z-50 bg-white md:bg-white/30 font-semibold">
            <div className="w-full h-16 flex  md:grid grid-cols-3 items-center justify-between px-5 md:px-10">
                <div className='flex items-center gap-3'>
                    <img src={Logo} alt="Logo Kebun Jitu" className='h-10 aspect-square object-contain' />
                    <p className='uppercase font-bold text-xl'>KEBUN JITU</p>
                </div>
                <div className='hidden md:flex items-center justify-center gap-3 font-semibold text-black capitalize'>

                    <LinkScroll
                        className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                        activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                    >
                        Home
                    </LinkScroll>

                    <LinkScroll
                        className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                        activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                        to="about"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                    >
                        Tentang
                    </LinkScroll>
                    <LinkScroll
                        className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                        activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                        to="visi"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                    >
                        Visi
                    </LinkScroll>
                    <LinkScroll
                        className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                        activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                        to="misi"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                    >
                        Misi
                    </LinkScroll>
                    <LinkScroll
                        className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                        activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={500}
                    >
                        Kontak
                    </LinkScroll>
                </div>
                <div className='hidden md:flex items-center justify-end '>
                    <input
                        type="text"
                        className={`rounded-full outline-none border-2  transition-all duration-500 ${openSearch ? "w-[300px] border-gray-300 px-3 py-1" : "w-0 border-0 border-transparent px-0 py-0 "}  focus:border-custom-orange hidden md:flex`}
                        placeholder='Search'
                    />
                    <button
                        type='button'
                        onClick={() => setOpenSearch(!openSearch)}
                        className=''
                    >
                        <img src={IcSearch} alt="Logo Kebun Jitu" className='h-8 aspect-square object-contain' />
                    </button>
                </div>
                <div className='md:hidden'>
                    <button
                        type='button'
                        onClick={() => setOpenMenu(!openMenu)}
                        className='relative w-10 aspect-square flex items-center justify-center '
                    >
                        <FaBars className={`w-8 h-8 ${openMenu ? "scale-0" : "scale-100"} transition-all duration-300`} />
                        <FaXmark className={`w-8 h-8 absolute text-red-500 ${openMenu ? "scale-100" : "scale-0"} transition-all duration-300`} />
                    </button>
                </div>
            </div>
            <div className={`w-full bg-white flex flex-col gap-3 justify-center items-center overflow-hidden md:hidden
                ${openMenu ? "h-[300px]" : "h-[0px]"} transition-all duration-500`}>
                <LinkScroll
                    className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                    activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                    to="home"
                    spy={true}
                    smooth={true}
                    offset={50}
                    duration={500}
                >
                    Home
                </LinkScroll>

                <LinkScroll
                    className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                    activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                    to="about"
                    spy={true}
                    smooth={true}
                    offset={50}
                    duration={500}
                >
                    Tentang
                </LinkScroll>
                <LinkScroll
                    className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                    activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                    to="visi"
                    spy={true}
                    smooth={true}
                    offset={50}
                    duration={500}
                >
                    Visi
                </LinkScroll>
                <LinkScroll
                    className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                    activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                    to="misi"
                    spy={true}
                    smooth={true}
                    offset={50}
                    duration={500}
                >
                    Misi
                </LinkScroll>
                <LinkScroll
                    className='hover:bg-custom-orange hover:text-white transition-colors px-5 py-2 rounded-full cursor-pointer'
                    activeClass="bg-custom-orange px-5 py-2 rounded-full text-white"
                    to="contact"
                    spy={true}
                    smooth={true}
                    offset={0}
                    duration={500}
                >
                    Kontak
                </LinkScroll>
            </div>
        </div>
    )
}

export default Navbar